import * as React from 'react'
import { timestampToLongDate } from 'src/share/utils/utils'
import { WrappedInput } from 'src/share/components/Input/Input'
import usePhotoViewer from 'src/share/components/PhotoViewer/usePhotoViewer';
import { CloseCaseReason, closeCaseTypes } from 'src/share/types/case/case';

const ClosedCasesRow = ({ closedCase, updatedCases, onSetUpdatedCases }) => {
  const { handleZoomInImage } = usePhotoViewer();
  function getValue(key: string, closeReason) {
    return updatedCases[key] ? updatedCases[key].closedReason : CloseCaseReason[closeReason] || CloseCaseReason.UNKNOWN;
  }
  return (
    <tr className="closed-cases-bulk__case">  
      <td>{closedCase.caseId}</td>
      <td className="closed-cases-bulk__child">
        {closedCase.children.map((child, i) => (
          <div key={i} className="child-photo__container" onClick={() => handleZoomInImage({ source: child.photo, boundingBoxes: [] })}>
            <img src={child.photo} alt={child.name} />
            <span>{child.name}</span>
          </div>
        ))}
      </td>
      <td>{timestampToLongDate(closedCase.date)}</td>
      <td>
        <WrappedInput
          type="select"
          md={22}
          value={getValue(closedCase.caseId, closedCase.closeReason)}
          onChange={(e: any) => onSetUpdatedCases(closedCase.caseId, e.currentTarget.value)}
          required={true}
        >
          {Object.keys(closeCaseTypes).map((key) => <option key={key} value={CloseCaseReason[key]}>{closeCaseTypes[key]}</option>)})
        </WrappedInput>
      </td>
    </tr>
  )
}

export default React.memo(ClosedCasesRow)
